import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../CSS/TindakLanjutAdmin.css";

function TindakLanjutKendalaTeknis() {
  const { id } = useParams();

  const [laporan, setLaporan] = useState(null);
  const [riwayat, setRiwayat] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    email: "",
    jenis: "",
    tindak: "",
    status: "",
  });

  // =====================
  // Ambil data laporan
  // =====================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://api-tibismart.tifpsdku.com/api/laporan/admin/all"
        );

        const selected = res.data.find(
          (item) => item.id_laporan === Number(id)
        );

        if (!selected) {
          setLaporan(null);
        } else {
          setLaporan(selected);
          setRiwayat([
            {
              id: selected.id_laporan,
              jenis: selected.jenis_kendala,
              tanggal: selected.tanggal_lapor?.split("T")[0],
              status: selected.status,
              tindak: selected.tindak_lanjut || "-",
            },
          ]);


          setFormData({
            email: selected.email || "",
            jenis: selected.jenis_kendala,
            tindak: selected.tindak_lanjut || "",
            status: selected.status || "",
          });
        }
      } catch (err) {
        console.error(err);
        alert("Gagal mengambil data laporan");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // =====================
  // Handle Form
  // =====================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.tindak || !formData.status) {
      alert("Mohon lengkapi semua data terlebih dahulu!");
      return;
    }

    try {
      await axios.put(
        `https://api-tibismart.tifpsdku.com/api/laporan/${id}/tindak-lanjut`,
        {
          tindak_lanjut: formData.tindak,
          status: formData.status,
        }
      );

      alert("Tindak lanjut berhasil disimpan");

      setRiwayat((prev) => [
        {
          id: laporan.id_laporan,
          jenis: laporan.jenis_kendala,
          tanggal: laporan.tanggal_lapor?.split("T")[0],
          status: formData.status,
          tindak: formData.tindak,
        },
        ...prev,
      ]);
    } catch (err) {
      console.error(err);
      alert("Gagal menyimpan tindak lanjut");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!laporan) return <p>Laporan tidak ditemukan</p>;

  return (
    <div className="tindak-page">
      <div className="main-contenttindak">
        <div className="content-container">
          <div className="laporan-form-section">

            {/* KIRI */}
            <div className="laporan-kendala">
              <h3>Laporan Kendala</h3>

              <label>Nama Lengkap</label>
              <input
                type="text"
                value={laporan.nama_pelapor || "-"}
                readOnly
              />

              <label>Role</label>
              <input
                type="text"
                value={laporan.role || "-"}
                readOnly
              />

              <label>Email</label>
              <input
                type="email"
                value={laporan.email || "-"}
                readOnly
              />

              <label>Jenis Kendala</label>
              <input
                type="text"
                value={laporan.jenis_kendala}
                readOnly
              />

              <label>Deskripsi Kendala</label>
              <textarea
                value={laporan.deskripsi_kendala}
                readOnly
              />

              {laporan.screenshot_file && (
                <>
                  <label>Screenshot Kendala</label>

                  <img
                    src={laporan.screenshot_file}
                    alt="Screenshot Kendala"
                    className="preview-kendala"
                  />

                  <div className="btn-group-download">


                    <a
                      href={laporan.screenshot_file}
                      download
                      className="download-btn"
                    >
                      Download
                    </a>
                  </div>
                </>
              )}
            </div>

            {/* KANAN */}
            <form className="form-tindak" onSubmit={handleSubmit}>
              <h3>Form Tindak Lanjut</h3>

              <label>Email</label>
              <input type="email" value={formData.email} readOnly />

              <label>Jenis Kendala</label>
              <input type="text" value={formData.jenis} readOnly />

              <label>Tindak Lanjut</label>
              <textarea
                name="tindak"
                value={formData.tindak}
                onChange={handleChange}
                placeholder="Tuliskan tindak lanjut..."
              />

              <label>Status Tindakan</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="">Pilih</option>
                <option value="Proses">Proses</option>
                <option value="Selesai">Selesai</option>
              </select>

              <button type="submit" className="submit-btn">
                Kirim
              </button>
            </form>
          </div>

          {/* RIWAYAT */}
          <div className="riwayat-section">
            <h3>Riwayat Tindak Lanjut Kendala</h3>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Jenis Kendala</th>
                  <th>Tanggal Lapor</th>
                  <th>Status</th>
                  <th>Tindak Lanjut</th>
                </tr>
              </thead>
              <tbody>
                {riwayat.map((r, i) => (
                  <tr key={i}>
                    <td>{r.id}</td>
                    <td>{r.jenis}</td>
                    <td>{r.tanggal}</td>
                    <td>{r.status}</td>
                    <td>{r.tindak}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="footertindak">
            © 2025 TibiSmart. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TindakLanjutKendalaTeknis;
